import { useState, useCallback, useEffect } from "react";
import ButtonCom from "../../../components/button/button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { RiDeleteBinLine } from "react-icons/ri";
import { AgGridReact } from "ag-grid-react";
import { useNavigate } from "react-router-dom";
import { MdOutlineAssignmentTurnedIn } from "react-icons/md";
import { PiUserCheck } from "react-icons/pi";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import TableSkeleton from "../../../components/table/TableSkeleton.js";
import Widgets from "../../../components/Widgets";
import CustomPagination from "../../../components/CustomPagination";
import {
  getInitials,
  getInitialColor,
} from "../../../services/commonServices.js";
import {
  getPayrollModelListPath,
  getStaffPayrollModelListPath,
  deletePayrollModelPath,
  assignEmployeePayrollModelPath,
} from "../../../services/config";
import {
  commonGetData,
  commonGetDataOne,
  commonGetDataTwo,
  commonGetDataThree,
  commonSaveData,
  initCommonState,
} from "../../../redux/slices/commonSlice";
import {
  fetchBranchData,
  initBranchState,
} from "../../../redux/slices/branchSlice.js";
import {
  fetchDepartmentData,
  initDepartState,
} from "../../../redux/slices/departmentSlice.js";

import { useDispatch, useSelector } from "react-redux";

import { HasPermission } from "../../../services/hasPermission.js";
import AssignEmployee from "../../../components/AssignEmployee";

const Payroll = ({ onChange }) => {
  const user = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : null;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.common);
  const branchStore = useSelector((state) => state.branch);
  const departmentStore = useSelector((state) => state.department);

  const [payrollList, setPayrollList] = useState([]);

  const [branchList, setBranchList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);

  const [state, setState] = useState({
    branchId: "0",
    departmentId: "0",
  });

  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [payrollId, setPayrollId] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [filterEmployeeList, setFilterEmployeeList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUsersList, setSelectedUsersList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const isSelectAll =
    selectedUsers.length === employeeList.length && employeeList.length > 0;
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const getPayrollModelList = useCallback(() => {
    dispatch(commonGetData(getPayrollModelListPath + user.user_id));
    dispatch(fetchBranchData());
    dispatch(fetchDepartmentData(user.user_id));
  }, []);

  useState(() => {
    getPayrollModelList();
  }, []);

  // const getEmployeeList = useCallback(() => {
  //   dispatch(commonGetDataOne(getStaffPayrollModelListPath(user.user_id, payrollId, state.branchId, state.departmentId)));
  // }, [payrollId, state.branchId, state.departmentId]);

  useEffect(() => {
    dispatch(
      commonGetDataOne(
        getStaffPayrollModelListPath(user.user_id, payrollId, state.branchId, state.departmentId)
      )
    );
  }, [user.user_id, payrollId, state.branchId, state.departmentId, dispatch]);


  const heading = [
    {
      headerName: "SNo",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 60,
      pinned: "left",
    },
    {
      headerName: "Model Name",
      cellRenderer: (rowData) => {
        return rowData?.data?.payrollModelName;
      },
      flex: 1,
    },

    {
      headerName: "Action",
      width: 200,
      pinned: "right",
      cellRenderer: (rowData) => {
        return (
          <>
            <div className="Branches-table-button">
              {HasPermission("Payroll Configurations", "create") && (
                <PiUserCheck
                  style={{
                    cursor: "pointer",
                    fontSize: 25,
                    marginRight: "10px",
                  }}
                  className="assign-icon"
                  onClick={() => {
                    handleShow();
                    handleAssignId(rowData?.data);
                  }}
                />
              )}

              {HasPermission("Payroll Configurations", "edit") && (
                <PiPencilSimpleLineBold
                  onClick={() => updatePayroll(rowData?.data)}
                  style={{ cursor: "pointer", fontSize: 30 }}
                  className="edit-icon"
                />
              )}
              {HasPermission("Payroll Configurations", "delete") && (
                <RiDeleteBinLine
                  onClick={() =>
                    handleDeletePayroll(rowData?.data?.payrollModelId)
                  }
                  style={{ cursor: "pointer", fontSize: 30 }}
                  className="delete-icon"
                />
              )}
            </div>
          </>
        );
      },
    },
  ];

  const handleModalClose1 = () => {
    setShow1(false);
  };

  const handleShow1 = () => setShow1(true);

  const handleDeletePayroll = (id) => {
    setPayrollId(id);
    handleShow1(true);
  };

  const handleDeleteSubmit = () => {
    const data = {
      path: deletePayrollModelPath,
      data: {
        userId: user.user_id,
        payrollModelId: payrollId,
      },
    };
    dispatch(commonSaveData(data));
  };

  const [payrollName, setPayrollName] = useState("");
  const handleAssignId = (data) => {
    const id = data.payrollModelId;
    setPayrollName(data.payrollModelName);
    setPayrollId(id);
    // getEmployeeList();
    // getEmployeeList(id, state.branchId, state.departmentId);
  };

  const handleModalClose = () => {
    setShow(false);
    setSearchQuery("")
    setState((pre) => ({
      ...pre,
      branchId: "",
      departmentId: "",
    }))
  };

  const handleShow = () => setShow(true);

  const selectUser = (event, userId, user) => {
    const isChecked = event.target.checked;
    setSelectedUsers((prevSelected) =>
      isChecked
        ? [...prevSelected, userId]
        : prevSelected.filter((id) => id !== userId)
    );

    setSelectedUsersList((prevSelected) =>
      isChecked
        ? [...prevSelected, user]
        : prevSelected.filter((u) => u.staffId !== user.staffId)
    );
  };

  const SelectAll = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      const allUserIds = employeeList.map((row) => row.staffId);
      const allUserList = employeeList.map((row) => row);
      setSelectedUsers(allUserIds);
      setSelectedUsersList(allUserList);
    } else {
      setSelectedUsers([]);
      setSelectedUsersList([]);
    }
  };

  const handleAssignShiftSubmit = (e) => {
    e.preventDefault();
    const data = {
      path: assignEmployeePayrollModelPath,
      data: {
        userId: user.user_id,
        staffId: selectedUsers.toString(),
        payrollModelId: payrollId,
      },
    };
    dispatch(commonSaveData(data));
  };

  const updatePayroll = (data) => {
    // Store the full model data so PayrollConfiguration can read it on mount
    localStorage.setItem("payroll-data", JSON.stringify(data));
    // Switch to edit view within the payroll tab (no page navigation)
    onChange(false);
  };

  useEffect(() => {
    if (commonState.commonGetSuccess || commonState.commonGetError) {
      if (commonState.commonGetSuccess) {
        setPayrollList(commonState.commonGetData);
      }
      if (commonState.commonGetError) {
        setPayrollList([]);
      }
      dispatch(initCommonState());
    }
    if (commonState.commonGetOneSuccess || commonState.commonGetOneError) {
      if (commonState.commonGetOneSuccess) {
        if (searchQuery != "") {
          searchEmployees(searchQuery, commonState.commonGetOneData)
        } else {
          setEmployeeList(commonState.commonGetOneData);
          setFilterEmployeeList(commonState.commonGetOneData);

          const initiallySelected = commonState.commonGetOneData
            .filter((row) => row.payrollAssignedStatus === "1") // Check API ka "selected: true"
            .map((row) => row.staffId);

          setSelectedUsers(initiallySelected);

          const initiallySelectedUsers = commonState.commonGetOneData
            .filter((row) => row.payrollAssignedStatus === "1") // Check API ka "selected: true"
            .map((row) => row);
          setSelectedUsersList(initiallySelectedUsers);
        }


        dispatch(initCommonState());
      }

      if (commonState.commonGetOneError) {
        setEmployeeList([]);
        setFilterEmployeeList([]);
        setSelectedUsers([]);
        setSelectedUsersList([]);
        dispatch(initCommonState());
      }
    }
    if (commonState.commonSuccess || commonState.commonError) {
      commonState.commonSuccess
        ? toast.success(commonState.commonMessage)
        : toast.error(commonState.commonMessage);
      getPayrollModelList();
      handleModalClose();
      handleModalClose1();
      dispatch(initCommonState());
    }

    if (departmentStore.depGetSuccess) {
      setDepartmentList(departmentStore.depGetData);
      dispatch(initDepartState());
    }

    if (branchStore.brnGetSuccess) {
      setBranchList(branchStore.brnGetData);
      dispatch(initBranchState());
    }
  }, [dispatch, commonState, departmentStore, branchStore]);

  const searchEmployees = (val, dataList) => {
    setSearchQuery(val);
    const filteredEmployees = dataList.filter((v) =>
      v.full_name.toLowerCase().includes(val.toLowerCase()) ||
      v.employee_id.toLowerCase().includes(val.toLowerCase())
    );
    setEmployeeList(filteredEmployees);
    setFilterEmployeeList(dataList)
  };

  const updateViewList = () => {
    onChange(false);
  };

  const paginationPageSize = 10;

  const handleInputChange = ({ target: { name, value } }) => {
    setState((preState) => ({
      ...preState,
      [name]: value,
    }));
  };

  useEffect(() => {
    console.log(state);
  }, [state]);

  return (
    <div
      className="mt-2"
      style={{
        position: "fixed",
        width: "calc(100%)",
        height: "calc(100vh-76px)",
        zIndex: "2",
      }}
    >
      <Widgets
        icon={<span className="color-white">Payroll Module</span>}
        button={
          HasPermission("Payroll Configurations", "create") && (
            <div style={{ width: "210px" }}>
              <ButtonCom
                type={"button"}
                class_name={"p_btn universal-btn"}
                text="+ Create Salary Module"
                url_or_onclick={updateViewList}
                icon={null}
                width={""}
              />
            </div>
          )
        }
        body={
          <>
            <div
              className="ag-theme-quartz custom-grid mt-2"
              style={{
                height: "calc(100vh - 275px)",
                width: "100%",
                padding: "0px 40px",
              }}
            >
              {commonState.commonGetLoading ? (
                <TableSkeleton />
              ) : (
                <AgGridReact
                  rowData={Array.isArray(payrollList) ? payrollList : []}
                  columnDefs={heading}
                  omLayout="autoHeight"
                  pagination={true}
                  paginationPageSize={paginationPageSize}
                  onGridReady={onGridReady}
                />
              )}
            </div>
            <div className="d-flex align-items-center justify-content-between custom-pagination px-5">
              {gridApi && <CustomPagination gridApi={gridApi} />}
            </div>
          </>
        }
      />

      <Modal show={show1} onHide={handleModalClose1} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Delete Payroll Model</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure! to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button
            style={{
              backgroundColor: "gray",
              color: "#fff",
              marginRight: "5px",
              border: "none",
            }}
            onClick={handleModalClose1}
          >
            Cancel
          </Button>
          <Button
            style={{ backgroundColor: "red", color: "#fff", border: "none" }}
            onClick={handleDeleteSubmit}
          >
            {commonState.commonLoading ? "Deleting.." : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>

      <AssignEmployee
        isOpen={show}
        closeOpenDialog={handleModalClose}
        submitData={handleAssignShiftSubmit}
        isSelectAll={isSelectAll}
        SelectAll={SelectAll}
        selectedUsersList={selectedUsersList}
        employeeList={employeeList}
        selectedUsers={selectedUsers}
        selectUser={selectUser}
        branchList={branchList}
        departmentList={departmentList}
        state={state}
        handleInputChange={handleInputChange}
        getData={""}
        searchQuery={searchQuery}
        searchEmployees={searchEmployees}
        outletName={payrollName}
        dataList={employeeList}
      />

      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  );
};

export default Payroll;
